module.exports = __webpack_public_path__ + "media/images/airwallex-04e89f7fae05c9efb36269efde7c11b2.png";